import { EntityType } from 'api'
import { ActionMeta, ActionsUnion, Nullable, createAction, getCurrentWindowId, primitive } from 'utils'
import { v4 as uuidv4 } from 'uuid'

export enum RepositoryActionTypes {
  REPOSITORY_UPDATE_FIELD = 'REPOSITORY_UPDATE_FIELD',
  REPOSITORY_UPDATE_META = 'REPOSITORY_UPDATE_META',
  REPOSITORY_REVERT_UPDATES = 'REPOSITORY_REVERT_UPDATES',
  REPOSITORY_RESET = 'REPOSITORY_RESET'
}

type UpdateOptions = Omit<ActionMeta, 'sourceWindowId'>

export const RepositoryActions = {
  updateField: (
    entityType: EntityType,
    entityId: string,
    fieldName: string,
    fieldValue: Nullable<primitive>,
    rawValue?: primitive,
    options: UpdateOptions = {}
  ) => {
    return createAction(
      RepositoryActionTypes.REPOSITORY_UPDATE_FIELD,
      { entityType, entityId, fieldName, fieldValue, rawValue, correlationId: uuidv4() },
      { sourceWindowId: getCurrentWindowId(), ...options }
    )
  },
  updateMeta: (entityType: EntityType, entityId: string, metaName: string, metaValue: primitive, options: UpdateOptions = {}) => {
    return createAction(
      RepositoryActionTypes.REPOSITORY_UPDATE_META,
      { entityType, entityId, metaName, metaValue },
      { sourceWindowId: getCurrentWindowId(), ...options }
    )
  },
  revertUpdates: (entityType: EntityType, entityId: string, options: UpdateOptions = {}) => {
    return createAction(
      RepositoryActionTypes.REPOSITORY_REVERT_UPDATES,
      { entityType, entityId },
      { sourceWindowId: getCurrentWindowId(), ...options }
    )
  },
  repositoryReset: () => createAction(RepositoryActionTypes.REPOSITORY_RESET)
}

export type RepositoryActionUpdateField = ReturnType<typeof RepositoryActions.updateField>
export type RepositoryActionUpdateMeta = ReturnType<typeof RepositoryActions.updateMeta>
export type RepositoryActionReset = ReturnType<typeof RepositoryActions.repositoryReset>
export type RepositoryActions = ActionsUnion<typeof RepositoryActions>
